export default {
  namespaced: true,
  state: {
    active: false,
    activePage: 0,
    totalPages: 0,
    cardContent: {
      showroom: {
        title: 'Шоу-рум LITHIUM',
        address: 'Вятка - Киров, Казанская 77б',
        schedule: [
          'ПН-ПТ 10.00-19.00',
          'СБ 10.00-17.00',
          'ВС Выходной'
        ],
        phone: [ '8(8332) 711-887' ],
        coords: [ 58.602782, 49.683750 ]
      },
      footer: [
        {
          key: '',
          title: '',
          value: 'MADE IN RUSSIA, Vyatka - Kirov'
        },
        {
          key: '',
          title: '',
          value: '© Lithium ' + new Date().getFullYear()
        }
      ],
      gallerySlides: [
        {
          index: 0,
          src: require('@/assets/img/catalog/diorama/slider1.jpg')
        },
        {
          index: 1,
          src: require('@/assets/img/catalog/diorama/slide1.jpg')
        },
        {
          index: 2,
          src: require('@/assets/img/catalog/diorama/slide2.jpg')
        },
        {
          index: 3,
          src: require('@/assets/img/catalog/diorama/slide3.jpg')
        },
        {
          index: 4,
          src: require('@/assets/img/catalog/diorama/slider1.jpg')
        },
        {
          index: 5,
          src: require('@/assets/img/catalog/diorama/slide1.jpg')
        },
        {
          index: 6,
          src: require('@/assets/img/catalog/diorama/slide2.jpg')
        },
        {
          index: 7,
          src: require('@/assets/img/catalog/diorama/slide3.jpg')
        }
      ],
      galleryThumbs: [
        {
          index: 0,
          src: require('@/assets/img/catalog/diorama/1.jpg')
        },
        {
          index: 1,
          src: require('@/assets/img/catalog/diorama/2.jpg')
        },
        {
          index: 2,
          src: require('@/assets/img/catalog/diorama/3.jpg')
        },
        {
          index: 3,
          src: require('@/assets/img/catalog/diorama/4.jpg')
        },
        {
          index: 4,
          src: require('@/assets/img/catalog/diorama/5.jpg')
        },
        {
          index: 5,
          src: require('@/assets/img/catalog/diorama/6.jpg')
        },
        {
          index: 6,
          src: require('@/assets/img/catalog/diorama/7.jpg')
        },
        {
          index: 7,
          src: require('@/assets/img/catalog/diorama/8.jpg')
        }
      ],
      slides: [
        {
          id: 1,
          title: 'Diorama',
          subtitle: 'Роскошь нового времени',
          image: require('@/assets/img/catalog/diorama/diorama-min.jpg')
        },
        {
          id: 2,
          title: 'Diorama',
          subtitle: 'Роскошь нового времени',
          image: require('@/assets/img/catalog/diorama/side.jpg')
        },
        {
          id: 3,
          title: 'Diorama',
          subtitle: 'Роскошь нового времени',
          image: require('@/assets/img/catalog/diorama/11.jpg')
        },
        {
          id: 4,
          title: 'Diorama',
          subtitle: 'Роскошь нового времени',
          image: require('@/assets/img/catalog/diorama/main_4.jpg')
        },
        {
          id: 5,
          title: 'Diorama',
          subtitle: 'Роскошь нового времени',
          image: require('@/assets/img/catalog/diorama/n5.jpg')
        },
        {
          id: 6,
          title: 'Diorama',
          subtitle: 'Роскошь нового времени',
          image: require('@/assets/img/catalog/diorama/n6.jpg')
        },
        {
          id: 7,
          title: 'Diorama',
          subtitle: 'Роскошь нового времени',
          image: require('@/assets/img/catalog/diorama/n7.jpg')
        },
        {
          id: 8,
          title: 'Diorama',
          subtitle: 'Роскошь нового времени',
          image: require('@/assets/img/catalog/diorama/main-bg.jpg')
        }
      ]
    }
  },
  actions: {
    scrollToTop ({ commit }) {
      commit('setActivePage', 0)
    }
  },
  mutations: {
    setActiveState (state, payload) {
      state.active = payload
    },
    setActivePage (state, page) {
      state.activePage = page
    },
    setTotalPages (state, count) {
      state.totalPages = count
    }
  },
  getters: {
    isActive: state => state.active,
    activePage: state => state.activePage,
    totalPages: state => state.totalPages,
    cardContent: state => state.cardContent
  }
}
